export default __webpack_public_path__ + "static/media/onboarding.a2f9c956.png";